/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { SidebarGlobal } from "../_SidebarGlobal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import Auth from "../../shared/Auth";

class ChatEditChannel extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
        this.submitRef = React.createRef();
    }

    componentDidMount() {
        Auth.getLogin(u => {
            this.setState({ user: u });
        });
        qreq.get('/api/user/list', j => {
            if (j.list) {
                this.setState({ users: j.list });
                this.load(j.list);
            }
        });

    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = (userList) => {
        if (this.props.params?.id) {
            qreq.get('/api/chat/channel/get/' + this.props.params?.id, j => {
                if (j.item) {
                    j.item.members.forEach(i => {
                        var find = userList.find(u => u.id === i.userID)
                        if (find)
                            find.selected = true;
                    });
                    this.setState({ info: j.item });
                }
                else
                    this.alert(j.errorMessage);
            }, this.unkownErrorCallback);
        }
    }

    toggleUser = user => {
        if (user.id === this.state.user?.id) return;
        if (this.state.users)
            this.setState({ users: this.state.users.map(i => i.id === user.id ? { ...i, selected: !i.selected } : i) });
    }

    submit = e => {
        e.preventDefault();
        const users = this.state.users?.filter(i => i.selected);
        if (users) {
            var info = { ...this.state.info, members: [] };
            users.forEach(i => {
                info.members.push({ userID: i.id });
            });
            if (this.state.info.id) {
                qreq.post('/api/chat/channel/custom/update', info, j => {
                    if (j.item) {
                        this.success('Channel updated.');
                        this.props.navigate('/chat/' + j.item.id);
                    }
                    else
                        this.alert(j.errorMessage);
                }, this.unkownErrorCallback);
            }
            else {
                qreq.post('/api/chat/channel/custom/create', info, j => {
                    if (j.item) {
                        this.success('Channel created.');
                        this.props.navigate('/chat/' + j.item.id);
                    }
                    else
                        this.alert(j.errorMessage);
                }, this.unkownErrorCallback);
            }
        }
    }

    render() {
        if (this.state.users?.filter(i => i.selected).length > 0) {
            setTimeout(() => {
                SidebarGlobal.setSubNav(<>
                    <button type="button" className="btn btn-success" onClick={() => this.submitRef.current.click()}><Icon icon="faSave" /> <span className="d-none d-md-inline">{this.state.info?.id ? 'Edit Channel' : 'Update Channel'}</span></button>
                </>);
            }, 100);
        }
        else
            SidebarGlobal.clearSubNav();

        return <div className="container-fluid">
            <h1><L>Create Channel</L></h1>
            <form onSubmit={this.submit}>
                <AppActions>
                    {this.state.users?.filter(i => i.selected).length > 0 && <button ref={this.submitRef} type="submit" className="btn btn-success btn-lg"><Icon icon="faSave" /> {this.state.info?.id ? 'Update Channel' : 'Create Channel'}</button>}
                </AppActions>
                <Card title="Channel">
                    <FormInput model={this.state.info} name="name" label="Channel Name" type="text" required />
                    <FormInput model={this.state.info} name="description" label="Description" type="text" />
                </Card>
                <Card title="Members">
                    <ul className="list-group">
                        {this.state.users?.map(i => <li role="button" className={'list-group-item' + (i.selected || i.id === this.state.user?.id ? ' active' : '')} onClick={() => this.toggleUser(i)}>{i.name}</li>)}
                    </ul>
                    {this.state.users?.filter(i => i.selected).length > 0 && <div className="mt-3">
                        <strong className="d-block"><L>Users Selected</L></strong>
                        {this.state.users?.filter(i => i.selected).map(i => <span className="d-inline-block me-2 bg-primary text-white rounded px-2">{i.name}</span>)}
                    </div>}
                </Card>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(ChatEditChannel);